"use client";
import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/ChatTabComp/ChatTabHeader";
import { Icon } from "@ospweb/sdk-ui";
import { cn } from "utils";

import { ChatTabMoreMenu, type ChatTabMoreMenuItemId } from "./ChatTabMoreMenu";
import type { ChatTabMoreMenuItemUiStateMap } from "@/src/utils/chatTabMoreMenuItemUiState";
import { MenuModal } from "@components";
import {
  useMainTabHeaderLogic,
  RENEW_THRESHOLD_MINUTES,
} from "@/src/hooks/useMainTabHeaderLogic";

const I18n = I18nUtil.createScoped(Translations);

export type { ChatTabMoreMenuItemId };

export { RENEW_THRESHOLD_MINUTES };

export type ChatTabHeaderProps = {
  className?: string;
  onBellClick?: () => void;
  onMoreMenuItemClick?: (itemId: ChatTabMoreMenuItemId) => void;
  moreMenuItemUi?: ChatTabMoreMenuItemUiStateMap;
};

export const ChatTabHeader = ({
  className,
  onMoreMenuItemClick,
  moreMenuItemUi,
}: ChatTabHeaderProps) => {
  const { labelConfig, isMenuOpen, openMenu, closeMenu, commonClickHandler } =
    useMainTabHeaderLogic("edgen_chat_memu_upgrade");

  return (
    <>
      <div
        className={cn(
          "h-14 px-4 flex items-center justify-between w-full",
          className,
        )}
        data-testid="chat-tab-header"
      >
        <div className="flex items-center gap-2">
          <button
            type="button"
            className="inline-flex items-center justify-center size-6 md:hidden"
            onClick={() => {
              openMenu();
            }}
            aria-label="Menu"
          >
            <Icon name="menu" size={24} className="text-content_primary" />
          </button>
          <div className="headline_regular_s text-content_primary md:block hidden">
            {I18n.t("Ask Ed")}
          </div>

          {labelConfig && (
            <button
              type="button"
              className={`flex items-center gap-[2px] rounded-[46px] px-2 py-[5px] body_bold_m ${labelConfig.className}`}
              onClick={() => commonClickHandler(labelConfig.onClick)}
              aria-label={labelConfig.text}
            >
              <Icon name="aura" size={16} />
              {labelConfig.text}
            </button>
          )}
        </div>
        <div className="flex items-center gap-4 relative">
          <ChatTabMoreMenu
            itemUi={moreMenuItemUi}
            onItemClick={onMoreMenuItemClick}
          />
        </div>
      </div>
      <MenuModal isOpen={isMenuOpen} onCancel={closeMenu} placement="left" />
    </>
  );
};
